import { useDisclosure, useMediaQuery } from '@chakra-ui/react'

const useIsMobile = () => useMediaQuery(['(max-width: 768px)'], { fallback: [] })[0]

export { useDisclosure, useMediaQuery, useIsMobile }
